export default (theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.background.dark,
    color: theme.palette.textColor.white,
    outline: 'none',
    touchAction: 'none',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    padding: theme.spacing(1, 2),
  },
  title: {
    // the host app colours h1–h6 globally, so restate the inherited white (counter too)
    color: 'inherit',
    flex: 1,
    minWidth: 0,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  counter: {
    color: 'inherit',
    marginRight: theme.spacing(2),
  },
  mobileOnly: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  button: {
    color: 'inherit',
    // MUI's own hover and the app-wide focus override would otherwise clear the dark fill
    '&, &:hover, &:focus': {
      backgroundColor: theme.palette.background.overlay,
    },
  },
  close: {
    marginLeft: 'auto',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius * 2,
  },
  body: {
    flex: 1,
    minHeight: 0,
    position: 'relative',
  },
  swiper: {
    height: '100%',
  },
  arrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
    '@media (hover: none) and (pointer: coarse)': {
      display: 'none',
    },
  },
  prev: {
    left: theme.spacing(1),
  },
  next: {
    right: theme.spacing(1),
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  hidden: {
    visibility: 'hidden',
  },
  status: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    padding: theme.spacing(1, 2),
  },
});
